import { useProductsByHandle } from '@/components/home/v2/shared';
import { formatPrice } from '@/lib/shopify';
import { trackGenericEvent } from '@/lib/crm/track';

/** Shopify is the price source of truth; returns formatted min price or null while loading. */
export function useMenuPrices() {
  const { map } = useProductsByHandle();
  return (handle: string): string | null => {
    const p = map.get(handle);
    const amt = p?.node.priceRange?.minVariantPrice;
    return amt ? formatPrice(amt.amount, amt.currencyCode) : null;
  };
}

export function trackMenuClick(item: string, destino: string, device: 'desktop' | 'mobile') {
  trackGenericEvent('menu_click', { item, destino, device });
}
